module.exports = __webpack_public_path__ + "02.jpg?9de216c922b26c0fe9637fca9cb0a669";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/02.jpg
// module id = 129
// module chunks = 0